import React from 'react';
import {Title, Video} from './../../Basics';
import Particle from './../../Particle'; //eslint-disable-line no-unused-vars

const Particle14 = () => (<div>

  <Title>How does an exoskeleton work?</Title>
  <Video
    source={require('./14_Exoskelett_Rewalk_v2.mp4')}
    poster={require('./P14_preview.png')}
  />

  <Particle
  number={15}
  />

</div>);

export default Particle14;



/** WEBPACK FOOTER **
 ** ./src/Particles/Particle14/Particle14_EN.js
 **/